<div class="re-w-full re-pb-20 re-text re-px-15
            md:re-w-600 md:re-mx-auto md:re-px-0
            lg:re-w-900">
  <bdo-progress-bar
    [wizardSteps]="wizardSteps"
    [activeWizardStep]="activeStep">
  </bdo-progress-bar>
</div>
<router-outlet></router-outlet>
<bdo-confirmation-popup [isVisible]="confirmationService.confirmationPopupIsVisible()"
                        [title]="confirmationService.config().title"
                        [cancelText]="confirmationService.config().cancelButtonText"
                        [confirmText]="confirmationService.config().confirmButtonText"
                        (confirmationResult)="onConfirmationResult($event)"
>
  <p>{{ confirmationService.config().body }}</p>
</bdo-confirmation-popup>
